import { RightWrapper } from "../../../components";
import { AvailableChannel } from "../..";
import IntegratedChannel from "./IntegratedChannel";
import { useAlert } from "@/";
import ShopifyCallback from "./components/ShopifyCallback";
import ChannelHeader from "./components/ChannelHeader";
import { useChannelTypes } from "./hooks/useChannelTypes";
import { useIntegratedChannels } from "./hooks/useIntegratedChannels";
import { useChannelCallbacks } from "./hooks/useChannelCallbacks";

const Channel = () => {
  const { AlertDialog } = useAlert();

  // Custom hooks to manage state and logic
  const channelTypes = useChannelTypes();
  const [integratedChannels, setIntegratedChannels] =
    useIntegratedChannels(channelTypes);
  const { handleRemoveChannel, handleUpdateChannel, onIntegrate } =
    useChannelCallbacks(setIntegratedChannels);

  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 m-2 pb-20 md:pb-4">
        <ChannelHeader />
        <AvailableChannel
          channelTypes={channelTypes}
          onIntegrate={onIntegrate}
          AlertDialog={AlertDialog}
        />
        <IntegratedChannel
          integratedChannels={integratedChannels}
          onRemoveChannel={handleRemoveChannel}
          onUpdateChannel={handleUpdateChannel}
          onIntegrate={onIntegrate}
          AlertDialog={AlertDialog}
        />
      </div>
      <ShopifyCallback />
      <AlertDialog />
    </RightWrapper>
  );
};

export default Channel;
